function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { FC, RefObject, CSSProperties, useCallback, useState } from 'react';
import cn from 'classnames';
import { Price, IPriceProps } from '../Price';
import { Delivery, IDeliveryProps } from '../Delivery';
import { ProductThumbnail, IProductThumbnailProps } from '../ProductThumbnail';
import { ProductCardNotification } from './Notification/ProductCardNotification';
import { ProductCardExtraLink } from './ExtraLink/ProductCardExtraLink';
import { ProductCardThumbnailContainer } from './ThumbnailContainer/ProductCardThumbnailContainer';
require("./ProductCard.css");
var styles = {
  "Root": "ProductCard-module-Root_1mQ",
  "Main": "ProductCard-module-Main_1pe",
  "TextLink": "ProductCard-module-TextLink_qti",
  "Delivery": "ProductCard-module-Delivery_2yO",
  "Name": "ProductCard-module-Name_1Yl",
  "PriceCurrent": "ProductCard-module-PriceCurrent_1J9",
  "squashed": "ProductCard-module-squashed_Itc",
  "Thumbnail": "ProductCard-module-Thumbnail_3m9",
  "disabled": "ProductCard-module-disabled_9Xr",
  "rowVariant": "ProductCard-module-rowVariant_2p8",
  "Price": "ProductCard-module-Price_30w",
  "higher": "ProductCard-module-higher_2K4"
};
export const ProductCardVariants = {
  row: 'row'
};
/**
 * @deprecated вместо этого используйте {@link Card}
 */
export const ProductCard = ({
  href,
  name,
  quantity,
  variant,
  thumbnailProps,
  deliveryProps,
  priceProps,
  target = '_self',
  extraLinkTarget = '_self',
  disabled = false,
  isSubscribe = false,
  onSubscribe,
  extraLinkHref,
  extraLinkText,
  style,
  className,
  innerRef,
  controlRef
}) => {
  const [isCounterVisible, setIsCounterVisible] = useState(Number(priceProps.countValue) > 0);
  const isVariantRow = variant === 'row';
  const showExtraLink = Boolean(isVariantRow && extraLinkHref && extraLinkText);
  const getSlicedName = useCallback(() => {
    const endOfSlicedName = ' \u2026';
    if (isVariantRow && name.length + quantity.length > 48) {
      return `${name.slice(0, 48 - endOfSlicedName.length - quantity.length)}${endOfSlicedName}`;
    } else if (!isVariantRow && name.length > 26) {
      return `${name.slice(0, 26 - endOfSlicedName.length)}${endOfSlicedName}`;
    }
    return name;
  }, [name, quantity, isVariantRow]);
  const handleChangeCounterVisibility = useCallback(isCounterVisible => {
    setIsCounterVisible(isCounterVisible);
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    ref: innerRef || controlRef,
    className: cn(styles.Root, styles[`${variant}Variant`], {
      [styles.disabled]: disabled,
      [styles.squashed]: isCounterVisible && !isVariantRow,
      [styles.higher]: showExtraLink
    }, className),
    style: style
  }, /*#__PURE__*/React.createElement(ProductCardThumbnailContainer, {
    disabled: disabled,
    href: href,
    target: target
  }, /*#__PURE__*/React.createElement(ProductThumbnail, _extends({}, thumbnailProps, {
    className: styles.Thumbnail,
    disabled: disabled,
    isFlexibleHeight: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.Main
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.MainTop
  }, /*#__PURE__*/React.createElement("a", {
    href: href,
    target: target,
    className: styles.TextLink
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.Name
  }, getSlicedName(), isVariantRow && ` ${quantity}`), !isVariantRow && /*#__PURE__*/React.createElement("div", {
    className: styles.Quantity
  }, quantity)), /*#__PURE__*/React.createElement(Delivery, _extends({}, deliveryProps, {
    className: styles.Delivery
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.MainBottom
  }, disabled ? /*#__PURE__*/React.createElement(React.Fragment, null, isVariantRow && /*#__PURE__*/React.createElement("div", {
    className: styles.PriceCurrent
  }, /*#__PURE__*/React.createElement(Price, {
    currentValue: priceProps.currentValue,
    size: "m"
  })), /*#__PURE__*/React.createElement(ProductCardNotification, {
    isSubscribe: isSubscribe,
    onSubscribe: onSubscribe
  })) : /*#__PURE__*/React.createElement(Price, _extends({}, priceProps, {
    onChangeCounterVisibility: handleChangeCounterVisibility,
    withCounter: true,
    className: styles.Price
  })), showExtraLink && /*#__PURE__*/React.createElement(ProductCardExtraLink, {
    href: extraLinkHref,
    text: extraLinkText,
    target: extraLinkTarget
  }))));
};
if (process.env.NODE_ENV !== 'production') {
  ProductCard.displayName = 'ProductCard';
}